import { wrapperBuilder } from './build';
import { MODES } from './others/Chat';

wrapperBuilder
  .getStaticsGeneratorsRegisterInstance()
  .addStaticProp('MODES', MODES);
